import Vue from "vue";
import { bus } from "./index";
import Toast from "vue-toastification";

Vue.use(Toast, [
    // You can set your default options here
]);

export default function init() {
    var app = new Vue({
        el: document.getElementById("notifications-app"),
        delimiters: ["${", "}"],
        data: {},
        mounted: function () {
            bus.$on("error", (err) => {
                this.$toast.error(err);
            });
            bus.$on("success", (msg) => {
                this.$toast.success(msg);
            });
            bus.$on("info", (msg) => {
                this.$toast(msg);
            });

            console.log(window.errorMsg);
            if (window.errorMsg !== undefined) {
                window.errorMsg.forEach(err => {
                    bus.$emit("error", err);
                });
            }
        },
        computed: {},
        methods: {},
        watch: {},
    });
}
